import { query, ENDPOINTS } from '../utils/service';

export const getProductList = (id) => query({
  endpoint: ENDPOINTS.getProductList,
  params: {
    subcategory: id,
  },
})